module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/no_snow-1499faa99a6d5ffe651698e514381e3e.svg";